import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@pwc/pwc-deals-ui';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Constants, NavigationNodeId } from '@pwc/pwc-deals-web-common';
import _get from 'lodash/get';

import { getNavigationTitle } from 'common/helpers/getCustomNavigationTitles';
import { getProject } from '../../../projectSlice';
import WelcomeBox from '../WelcomeBox';
import {
  getUserFeatureEnabled,
  saveUserFeatureEnabled,
} from '../../../../../common/services/userFeatureToggleService';
import './WelcomeBoxQuickStart.scss';

const iconSize = 24;

const WelcomeBoxQuickStart = () => {
  const [featureEnabled, setFeatureEnabled] = useState(null);
  const { t } = useTranslation();
  const project = useSelector(getProject);
  const KFATitle = getNavigationTitle(NavigationNodeId.KEY_FOCUS_AREAS);

  useEffect(() => {
    let isMounted = true;
    const launch = async () => {
      if (project.id) {
        const result = await getUserFeatureEnabled(
          project.id,
          Constants.FEATURE_NAMES.WELCOME_BOX
        );
        setFeatureEnabled(_get(result, 'enabled', false));
      }
    };

    if (isMounted) {
      launch();
    }

    return () => {
      isMounted = false;
    };
  }, [project.id]);

  if (featureEnabled === null || featureEnabled === false) {
    return null;
  }

  const handleDismiss = async () => {
    await saveUserFeatureEnabled(
      project.id,
      Constants.FEATURE_NAMES.WELCOME_BOX,
      false
    );
    setFeatureEnabled(false);
  };

  return (
    <div className="welcome-box-quick-start">
      <WelcomeBox>
        <button
          className="ui-button button-no-appearance"
          aria-label="Close welcome box"
          onClick={handleDismiss}
          type="button"
          data-testid="welcome-box-dismiss-button"
        >
          <Icon
            name="close"
            className="fill icon-white"
            width="18"
            height="18"
          />
        </button>
        <p>
          {t('startBuildingmsg')}{' '}
          <span className="nowrap">
            <Icon
              name="add"
              width={iconSize}
              fill="#ffff"
              className="welcome-paragraph-icon fill"
            />{' '}
            {t('adding')}
          </span>{' '}
          a{' '}
          <span className="nowrap">
            <Icon
              name="hypothesis"
              width={iconSize}
              fill="#ffff"
              className="welcome-paragraph-icon fill"
            />{' '}
            <Link
              to={`${project.id}/key-focus-areas/create`}
              data-testid="hypothesis-welcome-link"
              aria-label="Key Focus Area"
              className="add-link"
            >
              {KFATitle}
            </Link>
          </span>{' '}
          or{' '}
          <span className="nowrap">
            <Icon
              name="analysis"
              width={iconSize}
              fill="#ffff"
              className="welcome-paragraph-icon fill"
            />{' '}
            <Link
              to={`${project.id}/analyses/create`}
              data-testid="analyses-welcome-link"
              aria-label="Analyses"
              className="add-link"
            >
              Analysis
            </Link>
          </span>
          , then{' '}
          <span className="nowrap">
            <Icon
              name="hyperlink"
              width={iconSize}
              fill="#ffff"
              className="welcome-paragraph-icon fill"
            />{' '}
            connect
          </span>{' '}
          {t('demonstrateMessage')}
        </p>
      </WelcomeBox>
    </div>
  );
};

export default WelcomeBoxQuickStart;
